/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { HTTPValidationError } from "./HTTPValidationError.ts";
import type { TokenDetailsResponse } from "./TokenDetailsResponse.ts";
import type { TokenMetadata } from "./TokenMetadata.ts";

export type GetTokenInfoByIdentifierV1TokensIdentifierGetPathParams = {
	/**
	 * @type string
	 */
	identifier: string;
};

export const getTokenInfoByIdentifierV1TokensIdentifierGetQueryParamsNetworkEnum =
	{
		REGTEST: "REGTEST",
		MAINNET: "MAINNET",
	} as const;

export type GetTokenInfoByIdentifierV1TokensIdentifierGetQueryParamsNetworkEnum =
	(typeof getTokenInfoByIdentifierV1TokensIdentifierGetQueryParamsNetworkEnum)[keyof typeof getTokenInfoByIdentifierV1TokensIdentifierGetQueryParamsNetworkEnum];

export type GetTokenInfoByIdentifierV1TokensIdentifierGetQueryParams = {
	/**
	 * @type string
	 */
	network: GetTokenInfoByIdentifierV1TokensIdentifierGetQueryParamsNetworkEnum;
	/**
	 * @description Limit for search results if identifier is a query string
	 * @minLength 1
	 * @maxLength 100
	 * @default 25
	 * @type integer | undefined
	 */
	limit?: number;
	/**
	 * @description Offset for search results if identifier is a query string
	 * @minLength 0
	 * @default 0
	 * @type integer | undefined
	 */
	offset?: number;
};

/**
 * @description Successful Response
 */
export type GetTokenInfoByIdentifierV1TokensIdentifierGet200 =
	| TokenDetailsResponse
	| TokenMetadata[];

/**
 * @description Validation Error
 */
export type GetTokenInfoByIdentifierV1TokensIdentifierGet422 =
	HTTPValidationError;

export type GetTokenInfoByIdentifierV1TokensIdentifierGetQueryResponse =
	GetTokenInfoByIdentifierV1TokensIdentifierGet200;

export type GetTokenInfoByIdentifierV1TokensIdentifierGetQuery = {
	Response: GetTokenInfoByIdentifierV1TokensIdentifierGet200;
	PathParams: GetTokenInfoByIdentifierV1TokensIdentifierGetPathParams;
	QueryParams: GetTokenInfoByIdentifierV1TokensIdentifierGetQueryParams;
	Errors: GetTokenInfoByIdentifierV1TokensIdentifierGet422;
};
